export default "__VITE_ASSET__DLvSPIFo__"